
import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-md relative">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/e7430320e3bc3f9244a461515e2266b3/f73b13a61fb6c8e67d38e8bf1ed30007.jpeg" 
                alt="和明營造" 
                className="h-8 w-auto"
              />
            </Link>
          </div>
          <nav className="hidden md:flex space-x-8">
            <Link 
              to="/" 
              className="text-gray-700 hover:text-blue-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              首頁
            </Link>
            <Link 
              to="/about" 
              className="text-gray-700 hover:text-blue-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              關於我們
            </Link>
            <Link 
              to="/services" 
              className="text-gray-700 hover:text-blue-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              服務項目
            </Link>
            <Link 
              to="/projects" 
              className="text-gray-700 hover:text-blue-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              作品
            </Link>
            <Link 
              to="/contact" 
              className="text-gray-700 hover:text-blue-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              聯絡我們
            </Link>
          </nav>
          <div className="md:hidden">
            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-700 hover:text-blue-600 cursor-pointer"
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {/* 行動版選單 */}
      <div 
        className={`md:hidden absolute top-16 left-0 right-0 bg-white shadow-lg transition-all duration-300 ease-in-out ${
          isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
        }`}
      >
        <nav className="flex flex-col py-4">
          <Link 
            to="/" 
            onClick={() => setIsMobileMenuOpen(false)}
            className="px-6 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            首頁
          </Link>
          <Link 
            to="/about" 
            onClick={() => setIsMobileMenuOpen(false)}
            className="px-6 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            關於我們
          </Link>
          <Link 
            to="/services" 
            onClick={() => setIsMobileMenuOpen(false)}
            className="px-6 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            服務項目
          </Link>
          <Link 
            to="/projects" 
            onClick={() => setIsMobileMenuOpen(false)}
            className="px-6 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            作品
          </Link>
          <Link 
            to="/contact" 
            onClick={() => setIsMobileMenuOpen(false)}
            className="px-6 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            聯絡我們
          </Link>
        </nav>
      </div>
    </header>
  );
}
